<template>
    
    <span>
            
        <v-alert type="success" v-if="alarms.length == 0">
            {{ $t('No alarms found') }}
        </v-alert>
        
        <div class="d-flex flex-wrap">
            
            <v-card color="#585858" class="elevation-0 alarmCard" dark tile v-for="alarm in alarms" :key="alarm.id"  :class="get_prio_style(alarm.alarm_prio)">

                <v-card-text class="alarmCardText" :class="get_prio_style(alarm.alarm_prio)">

                    <h2 class="pb-2">
                        {{ alarm.name }}
                    </h2>

                    <p>
                        {{ getDeviceName(alarm.device_id) }} 
                        {{ get_lastupdated(alarm.last_updated) }}
                    </p>

                    <p v-if="alarm.discription">{{ alarm.discription }}</p>

                </v-card-text>

                <v-divider></v-divider>

            </v-card>

            <!-- <v-card color="#585858" class="elevation-0" dark tile >

                <v-card-text class="alarmCard redAlarmCard">

                    <h2 class="pb-2">
                        Error_Gasanalytics_Dewpoint_L
                    </h2>
                    <p><a href="#" class="alarmLink">Afleverskid Byk</a> - Create date: 12-03-2020 12:22</p>
                    <p>CH4 niveau ligt beneden de ingestelde ondergrens van de ATO met Bykcera (55%)</p>

                </v-card-text>

                <v-divider></v-divider>

            </v-card> -->
        
        </div>

    </span>

</template>

<style scoped>

.alarmCard {
    width: 100%;
}

.alarmCardText {
    color: white !important;
}

.redAlarmCard {
    color: red !important;
}

.alarmLink {
    color: #01b5d8;
}

</style>

<script>

import { mapGetters } from "vuex" ;
import moment from "moment-timezone" ;

export default {

  name: 'Footer',
  computed: {

      ...mapGetters({
          app: "app/data",
          alarms: "reporters/alarms",
          devices: "reporters/devices",
      }),

    },

    methods: {
        
        getDeviceName(device_id){

            let deviceSearch = this.devices.filter(function( obj ) {
                return obj.id === parseInt(device_id) ;
            });

            return deviceSearch[0].name ;

        },
        openDevice(device_id){
 
            //this.$store.commit("app/setPopup", { name: 'alarms', value: false });
  
            return '/device/'+device_id ;

        },
        get_prio_style(prio){

            if(prio == 1){
                return 'redAlarmCard order-first';
            }

        },
        get_lastupdated(last_updated){

            if(last_updated){

                let newDate = moment.unix(last_updated).tz("Europe/Amsterdam").format("DD-MM-YYYY HH:mm:ss") ;
              
                return ' - '+this.$t('Last modified')+': '+newDate ;

            }

            return '';

        }

    },

  

};

</script>
